/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.5 2A.75.75 0 004 2v1.944H2.75A1.75 1.75 0 001 5.694v14.094c0 .967.784 1.75 1.75 1.75h18a1.75 1.75 0 001.75-1.75V5.694a1.75 1.75 0 00-1.75-1.75H19.5V2A.75.75 0 0018 2v1.944H5.5V2zM18 6v-.556H5.5V6A.75.75 0 014 6v-.556H2.75a.25.25 0 00-.25.25v14.094c0 .138.112.25.25.25h18a.25.25 0 00.25-.25V5.694a.25.25 0 00-.25-.25H19.5V6A.75.75 0 0118 6zM7.75 14a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm-7-5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm-9 9a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z" _fill="#000"/>'
  }
})
